import React, { useEffect, useState } from "react";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Footer from "../../examples/Footer";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDButton from "../../components/MDButton";
import {
  FormControl,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useNavigate, useParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { getFields } from "../dialog/formfields";
import PropTypes from "prop-types";
import DataTableConfig from "../Tables/DataTableConfig";
import tableData from "../tabledata";
import useConfigApi from "../utils/configapi";
import Endpoints from "../utils/endpoints";
import toast from "react-hot-toast";
import MDTypography from "../../components/MDTypography";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

let groupConfigs = [];

const ConfigInfoBox = ({ selectedValues }) => {
  const selectedConfig = groupConfigs.find((grp) => grp.grpId === selectedValues?.grpId);
  if (!selectedConfig) return null;

  return (
    <MDBox
      sx={{
        padding: "16px",
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
        backgroundColor: "#fff",
        width: "80%",
        fontSize: "14px",
        lineHeight: "1.6",
      }}
    >
      <div>
        <label>Control name Config: </label>{" "}
        <label style={{ color: "#3C96EF" }}>{selectedConfig.grpConfigName}</label>
      </div>
      <div>
        <label>Ctrl Type: </label>{" "}
        <label style={{ color: "#3C96EF" }}>{selectedConfig.grpType}</label>
      </div>
      <div>
        <label>Control ID: </label>{" "}
        <label style={{ color: "#3C96EF" }}>{selectedConfig.grpId}</label>
      </div>
    </MDBox>
  );
};

ConfigInfoBox.propTypes = {
  selectedValues: PropTypes.shape({
    grpId: PropTypes.string,
  }),
};


function DeviceConfig() {
  const { deviceConfigColumns } = tableData();
  const { deviceConfigFields } = getFields();
  const [deviceConfig, setDeviceConfig] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeRow, setActiveRow] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const { groupId } = useParams();
  const [dialogData, setDialogData] = React.useState(null);
  const [dialogMode, setDialogMode] = React.useState("create");
  const [dialogTitle, setDialogTitle] = React.useState("Create DeviceConfig");
  const [deviceConfigFieldsModified, setDeviceConfigFieldsModified] = useState([]);
  const api = useConfigApi();
  const navigate = useNavigate();
  const [clearConfig, setClearConfig] = useState(false);
  const [serialOptions, setSerialOptions] = useState([]);
  const [unmappedDevices, setUnmappedDevices] = useState([]);
  const [bulkFile, setBulkFile] = useState(null);
  const fileInputRef = React.useRef();

  // Clone dialog state
  const [cloneOpen, setCloneOpen] = useState(false);
  const [cloneSourceDevice, setCloneSourceDevice] = useState(null);
  const [cloneFormData, setCloneFormData] = useState({
    terminalName: "",
    terminalBrand: "",
    serialNumber: "",
    deviceStatus: "Active",
  });

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setActiveRow(row);
  };
  const openModal = () => {
    setDialogMode("create");
    setModalOpen(true);
    setDialogTitle("Create DeviceConfig");
    if (groupId) {
      setDialogData({ grpId: groupId }); // pre-fill the field});
    } else {
      setDialogData({});
    }
    updateDeviceConfigFields("create", groupId);
  };

  const closeModal = () => {
    setModalOpen(false);
    setDialogData(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRow(null);
  };

  const openDelete = (row) => {
    setDialogMode("delete");
    setDialogTitle("Delete DeviceConfig");
    // setDialogData({ slNo: row?.slNo });
    setDialogData(row); 
    setModalOpen(true);
  };


  const handleActionClick = (action: string, item) => {
    if (action === "View") {
      setModalOpen(true);
      setDialogMode("view");
      setDialogTitle("View DeviceConfig");
      fetchControlConfigByDevice(activeRow, "viewDevice");
    } else if (action === "Edit") {
      setModalOpen(true);
      setDialogMode("edit");
      setDialogTitle("Edit DeviceConfig");
      fetchControlConfigByDevice(activeRow, "editDevice");
    } else if (action === "editParam") {
      console.log(`${item.slNo}`);
      fetchControlConfigByDevice(item, "editParam");
    } else if (action === "Delete") {
      // setModalOpen(true);
      // setDialogMode("delete");
      // setDialogTitle("Delete DeviceConfig");
      // setDialogData(activeRow);
      openDelete(item || activeRow);
    } else if (action === "permanentDelete") {
      // setModalOpen(true);
      // setDialogMode("delete");
      // setDialogTitle("Delete DeviceConfig");
      // setDialogData(activeRow);
      openDelete(item || activeRow);
    }

    handleMenuClose();
  };

  const handleDialogSubmit = (formData) => {
    console.log("Submitted data:", formData, dialogMode);
    // Call your API here
    if (dialogMode === "create") {
      // Handle create logic here
      if (groupId) {
        api
          .put(Endpoints.devices.createOrUpdate, formData)
          .then((response) => {
            toast.success("Device config successfully updated.");
            setModalOpen(false);
            fetchDevicesConfig().catch(console.error); // Fetch the latest data after editing
          })
          .catch((error) => {
            const responseMessage = error?.response?.data?.responseMessage;
            if (
              responseMessage?.includes("duplicate key value") &&
              responseMessage?.includes("serial_number")
            ) {
              toast.error("Serial number already exists.");
            } else {
              toast.error("Internal error occurred while creating.");
            }
          });
      } else {
        api
          .post(Endpoints.devices.createOrUpdate, formData)
          .then((response) => {
            toast.success("Device config successfully created.");
            setModalOpen(false);
            fetchDevicesConfig().catch(console.error); // Fetch the latest data after creation
          })
          .catch((error) => {
            const responseMessage = error?.response?.data?.responseMessage;
            if (
              responseMessage?.includes("duplicate key value") &&
              responseMessage?.includes("serial_number")
            ) {
              toast.error("Serial number already exists.");
            } else {
              toast.error("Internal error occurred while updating.");
            }
          });
      }
    } else if (dialogMode === "edit") {
      api
        .put(Endpoints.devices.createOrUpdate, formData)
        .then(({data }) => {
          toast.success("Device config successfully updated.");
          setModalOpen(false);
          // fetchDevicesConfig().catch(console.error); // Fetch the latest data after editing
          const updated = data?.data ?? formData;
          const updatedId = updated?.slNo ?? dialogData?.slNo;
          // In-place patch so the row doesn't move; preserve computed cells like `action` & `duplicate`
          setDeviceConfig(prevRows =>
            prevRows.map(row =>
              row.slNo === updatedId
              ? { ...row, ...updated }                  // spread existing row first to keep action/duplicate
              : row
            )
          );
        })
        .catch((error) => {
          toast.error("Internal error occurred while updating.");
        });
    }
  };

  const handleDialogDelete = (formData) => {
    // if (!formData.terminalId) {
    //   toast.error("Missing Terminal ID for deletion.");
    if (!formData?.slNo) {
      toast.error("Missing device id.");
      return;
    }
    api
      .delete(Endpoints.devices.deleteById(formData.slNo))
      .then(() => {
        toast.success(`Device config ${formData.slNo} successfully deleted.`);
        fetchDevicesConfig().catch(console.error);
      })
      .catch((err) => {
        const msg = err?.response?.data?.responseMessage || "Error deleting device config.";
        toast.error(msg);
        // toast.error("Error deleting device config.");
      })
      .finally(() => {
        setModalOpen(false);
        setAnchorEl(null);
        setActiveRow(null);
      });
  };

  useEffect(() => {
    fetchDevicesConfig().catch(console.error);
  }, [groupId]);

  const fetchControlConfigByDevice = async (deviceData, route) => {
    try {
      const apiResponse = await api.get(Endpoints.devices.getByTerminalId(deviceData.slNo));
      const fullResponse = apiResponse?.data?.data || {};
      const item = fullResponse?.controlConfig;
      const devices = fullResponse?.deviceConfig;
      if (route === "editDevice") {
        const dataToSet = {
          ...devices,
          grpId: devices?.groupConfig?.grpId,
          controlConfigSerialNumber: item?.slNo,
          grpIdText: devices?.groupConfig?.grpConfigName,
          controlSerialNumberText: item?.controlName?.split("_")[0] ?? "",
          serialNumber: devices?.serialNumber,
        };
        console.log("dataToSet", dataToSet);
        setDialogData(dataToSet);
        updateDeviceConfigFields("edit", groupId, dataToSet);
      } else if (route === "viewDevice") {
        const dataToSet = {
          ...devices,
          grpId: devices?.groupConfig?.grpId,
          controlConfigSerialNumber: item?.slNo,
          grpIdText: devices?.groupConfig?.grpConfigName,
          controlSerialNumberText: item?.controlName?.split("_")[0] ?? "",
          serialNumber: devices?.serialNumber,
        };
        console.log("dataToSet", dataToSet);
        setDialogData(dataToSet);
        updateDeviceConfigFields("view", groupId, dataToSet);
      } else {
        if (item === null) {
          toast.error("No configuration mapped with device.");
        } else {
          navigate(`/control-config-view/`, {
            state: { item },
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchDevicesConfig = async () => {
    try {
      // 1. Fetch Devices
      const devicesResponse = await api.get(
        groupId ? Endpoints.devices.getByGroupId(groupId) : Endpoints.devices.getAll(false)
      );
      const devices = devicesResponse?.data?.data || [];

      // 2. Fetch Groups
      const groupsResponse = await api.get(Endpoints.groups.getAll(false));
      const groups = groupsResponse?.data?.data || [];
      groupConfigs = groups;

      if (groupId) {
        const snResponse = await api.get(Endpoints.devices.fetchUnmapDevice());
        const unmapDevices = snResponse?.data?.data || [];
        const options = unmapDevices.map((unmapDevice) => ({
          label: unmapDevice.serialNumber,
          value: unmapDevice.serialNumber,
        }));
        setUnmappedDevices(unmapDevices);
        setSerialOptions(options);
      } else {
        setSerialOptions([]);
        setUnmappedDevices([]);
      }

      // 3. Format Table Data
      const modifiedDevices = devices.map((item) => {
        const action = (
          <>
            <MDTypography
              display="inline"
              color="info"
              sx={{
                borderBottom: "1px solid #2196F3",
                paddingBottom: "1px",
                fontSize: "14px",
                textTransform: "capitalize",
                fontWeight: "light",
                cursor: "pointer",
                marginRight: 1,
              }}
              onClick={() => handleActionClick("editParam", item)}
            >
              Edit Parameters
            </MDTypography>
            <IconButton onClick={(e) => handleMenuOpen(e, item)}>
              <MoreHorizIcon />
            </IconButton>
          </>
        );

        // Clone action column
        const duplicate = (
          <MDTypography
            display="inline"
            color="info"
            sx={{
              borderBottom: "1px solid #2196F3",
              paddingBottom: "1px",
              fontSize: "14px",
              textTransform: "capitalize",
              fontWeight: "light",
              cursor: "pointer",
              marginRight: 1,
            }}
            onClick={() => handleCloneClick(item)}
          >
            Clone
          </MDTypography>
        );

        return { ...item, action, duplicate };
      });

      setDeviceConfig(modifiedDevices);

      updateDeviceConfigFields(dialogMode, groupId);
    } catch (error) {
      toast.error("Error while fetching devices or group data.");
      console.error(error);
    }
  };

  const updateDeviceConfigFields = (mode, grpId, dialogdata) => {
    const groupOptions = groupConfigs.map((group) => ({
      label: group.grpConfigName,
      value: group.grpId,
    }));

    if (dialogdata?.controlConfigSerialNumber && mode === "edit") {
      setClearConfig(true);
    } else {
      setClearConfig(false);
    }
    const showTextFields = !!dialogdata?.grpId && !!dialogdata?.controlConfigSerialNumber;

    const updatedFields = deviceConfigFields.map((field) => {
      if (field.name === "grpId") {
        return {
          ...field,
          options: groupOptions,
          hidden: showTextFields,
          readonly: !!groupId,
        };
      }
      if (field.name === "grpIdText") {
        return {
          ...field,
          hidden: !showTextFields,
        };
      }
      if (field.name === "controlSerialNumberText") {
        return {
          ...field,
          options: groupOptions,
          hidden: !showTextFields,
        };
      }
      if (field.name === "controlConfigSerialNumber") {
        return {
          ...field,
          hidden: showTextFields,
        };
      }
      if (field.name === "serialNumber") {
        return {
          ...field,
          type: grpId && mode === "create" ? "select" : "text",
          options: serialOptions,
          readonly: mode === "view",
        };
      }
      return field;
    });

    setDeviceConfigFieldsModified(updatedFields);
  };

  useEffect(() => {
    if (dialogData?.grpId) {
      fetchControlConfigsByGroup(dialogData.grpId);
    }
  }, [dialogData?.grpId]);

  const fetchControlConfigsByGroup = async (grpId) => {
    try {
      const response = await api.get(Endpoints.controlConfig.getByGrpId(grpId));
      const controlConfigs = response?.data?.data || [];
      const controlConfigOptions = controlConfigs.map((config) => ({
        label: config.controlName,
        value: config.slNo,
      }));
      const updatedFields = deviceConfigFieldsModified.map((field) => {
        if (field.name === "controlConfigSerialNumber") {
          return { ...field, options: controlConfigOptions };
        }
        return field;
      });

      console.log("updated fields", updatedFields);
      setDeviceConfigFieldsModified(updatedFields);
      if (controlConfigOptions.length > 0 && groupId && dialogMode === "edit") {
        setDialogData((prev) => ({
          ...prev,
          controlConfigSerialNumber: controlConfigOptions[0].value,
        }));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleClearConfig = async (formData) => {
    try {
      try {
        const response = await api.delete(Endpoints.devices.unmapControlConfig(formData.slNo));
        toast.success("Device Configuration cleared!");
        setDialogData((prev) => ({
          ...prev,
          grpId: null,
          controlConfigSerialNumber: null,
        }));

        updateDeviceConfigFields("clearconfig");
      } catch (e) {
        console.log(e);
      }
    } catch (error) {
      console.error("Failed to clear config", error);
    }
  };
  const bulkUpload = () => {
    fileInputRef.current.click(); // Opens file picker
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await api.post(Endpoints.devices.bulkUpload, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("File uploaded successfully!");
      fetchDevicesConfig().catch(console.error);
    } catch (error) {
      toast.error("File upload failed.");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const isExcel = file.name.endsWith(".xls") || file.name.endsWith(".xlsx");
    if (!isExcel) {
      alert("Only .xls or .xlsx files are allowed.");
      return;
    }
    setBulkFile(file);
    uploadFile(file); // Trigger upload immediately or show confirm dialog
  };

  // Clone handlers
  const handleCloneClick = async (sourceDevice) => {
    try {
      // Fetch full source device details including grpId and controlConfig
      const apiResponse = await api.get(Endpoints.devices.getByTerminalId(sourceDevice.slNo));
      const fullResponse = apiResponse?.data?.data || {};
      const deviceConfig = fullResponse?.deviceConfig;
      
      if (!deviceConfig?.groupConfig?.grpId) {
        toast.error("Source device has no Group mapped. Cannot clone.");
        return;
      }

      setCloneSourceDevice({
        ...sourceDevice,
        grpId: deviceConfig.groupConfig.grpId,
        deviceConfigId: sourceDevice.slNo,
      });
      
      setCloneFormData({
        terminalName: "",
        terminalBrand: "",
        serialNumber: "",
        deviceStatus: "Active",
      });
      
      setCloneOpen(true);
    } catch (e) {
      toast.error("Failed to fetch source device details.");
      console.error(e);
    }
  };

  const closeCloneDialog = () => {
    setCloneOpen(false);
    setCloneSourceDevice(null);
    setCloneFormData({
      terminalName: "",
      terminalBrand: "",
      serialNumber: "",
      deviceStatus: "Active",
    });
  };

  const performClone = async () => {
    try {
      if (!cloneSourceDevice?.grpId) {
        toast.error("Missing Group ID from source device.");
        return;
      }
      if (!cloneSourceDevice?.deviceConfigId) {
        toast.error("Missing device config ID.");
        return;
      }
      if (!cloneFormData.terminalName || !cloneFormData.terminalBrand || !cloneFormData.serialNumber) {
        toast.error("Please fill in all required fields.");
        return;
      }

      const payload = {
        grpId: cloneSourceDevice.grpId,
        terminalBrand: cloneFormData.terminalBrand,
        terminalName: cloneFormData.terminalName,
        serialNumber: cloneFormData.serialNumber,
        deviceStatus: cloneFormData.deviceStatus,
        deviceConfigId: cloneSourceDevice.deviceConfigId,
      };

      const response = await api.post(Endpoints.devices.clone, payload);
      
      toast.success("Device cloned successfully.");
      closeCloneDialog();
      fetchDevicesConfig().catch(console.error);
    } catch (e) {
      const errorMsg = e?.response?.data?.responseMessage || "Failed to clone device.";
      toast.error(errorMsg);
      console.error(e);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid container justifyContent="flex-end">
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept=".xls,.xlsx"
              onChange={handleFileChange}
            />
            {!groupId && (
              <MDButton
                variant="gradient"
                color="info"
                onClick={bulkUpload}
                sx={{ mr: 3, mb: 1.5 }}
              >
                Bulk Upload here
              </MDButton>
            )}
            <MDButton variant="gradient" onClick={openModal} color="info" sx={{ mr: 3, mb: 1.5 }}>
              Add Device
            </MDButton>
          </Grid>
          <Grid item xs={12} lg={12}>
            <DataTableConfig
              table={{ columns: deviceConfigColumns, rows: deviceConfig }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              canSearch={true}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
      >
        <MenuItem onClick={() => handleActionClick("View")}>
          <IconButton size="small">
            <i className="material-icons">visibility</i>
          </IconButton>
          View
        </MenuItem>
        <MenuItem onClick={() => handleActionClick("Edit")}>
          <IconButton size="small">
            <EditIcon fontSize="small" />
          </IconButton>
          Edit
        </MenuItem>
        <MenuItem onClick={() => handleActionClick("Delete")}>
          <IconButton size="small" color="error">
            <EditIcon fontSize="small" />
          </IconButton>
          Delete
        </MenuItem>
      </Menu>

      <Dialog open={isModalOpen} onClose={closeModal} maxWidth="sm" fullWidth>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent dividers>
          {dialogMode !== "delete" ? (
            <>
              <Grid container spacing={2} mt={1}>
                {deviceConfigFieldsModified.map((field) => {
                  if (field.hidden || (dialogMode === "create" && field.name === "slNo"))
                    return null;
                  return (
                    <Grid item xs={field.xs || 12} key={field.name}>
                      {field.type === "select" ? (
                        <FormControl fullWidth disabled={field.readonly || dialogMode === "view"}>
                          <InputLabel>{field.label}</InputLabel>
                          <Select
                            value={dialogData?.[field.name] || ""}
                            label={field.label}
                            onChange={(e) => {
                              const chosenSn = e.target.value;
                              setDialogData((prev) => ({
                                ...prev,
                                [field.name]: chosenSn,
                              }));

                              if (field.name === "serialNumber") {
                                const found = unmappedDevices.find(
                                  (d) => d.serialNumber === chosenSn
                                );
                                if (found) {
                                  setDialogData((prev) => ({
                                    ...prev,
                                    terminalName: found.terminalName,
                                    terminalBrand: found.terminalBrand,
                                    deviceStatus: found.deviceStatus,
                                    serialNumber: chosenSn,
                                    slNo: found.slNo,
                                  }));
                                } else {
                                  setDialogData((prev) => ({
                                    ...prev,
                                    terminalName: "",
                                    terminalBrand: "",
                                    deviceStatus: "",
                                    serialNumber: chosenSn,
                                  }));
                                }
                              }
                            }}
                            IconComponent={() => (
                              <ArrowDropDownIcon
                                sx={{ color: "black", fontSize: "25px !important" }}
                              />
                            )}
                            sx={{
                              height: "45px",
                              "& .MuiSelect-select": {
                                paddingTop: "14px",
                                paddingBottom: "14px",
                                display: "block",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              },
                            }}
                          >
                            {field.options?.map((opt) => (
                              <MenuItem key={opt.value} value={opt.value}>
                                {opt.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <TextField
                          label={field.label}
                          fullWidth
                          value={dialogData?.[field.name] || ""}
                          onChange={(e) =>
                            setDialogData((prev) => ({
                              ...prev,
                              [field.name]: e.target.value,
                            }))
                          }
                          disabled={field.readonly || dialogMode === "view"}
                        />
                      )}
                    </Grid>
                  );
                })}
              </Grid>
              <MDBox sx={{ mt: 3 }}>
                <ConfigInfoBox selectedValues={dialogData} />
              </MDBox>
            </>
          ) : (
            <MDBox sx={{ p: 3 }}>
              <MDTypography fontSize="1rem">
                {`Are you sure you want to delete Device name : ${dialogData?.terminalName || "this device"} 
                and Serial No: ${dialogData?.serialNumber || "N/A"}?`}
              </MDTypography>
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          {dialogMode === "edit" && clearConfig && (
            <MDButton onClick={() => handleClearConfig(dialogData)} color="warning">
              Clear Config
            </MDButton>
          )}
          {dialogMode !== "view" && dialogMode !== "delete" && (
            <MDButton onClick={() => handleDialogSubmit(dialogData)} color="info">
              Save
            </MDButton>
          )}
          <MDButton onClick={closeModal} color="light">
            Cancel
          </MDButton>
          {dialogMode === "delete" && (
            <MDButton
              onClick={() => {
                handleDialogDelete(dialogData);
                closeModal();
              }}
              color="error"
            >
              Yes
            </MDButton>
          )}
        </DialogActions>
      </Dialog>

      {/* Clone Device dialog */}
      <Dialog open={cloneOpen} onClose={closeCloneDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Clone Device</DialogTitle>
        <DialogContent dividers>
          <MDBox mb={2}>
            <MDTypography fontSize="0.95rem" sx={{ mb: 2 }}>
              Cloning from: <b>{cloneSourceDevice?.serialNumber}</b>
            </MDTypography>
            <MDTypography variant="caption" color="text" sx={{ mb: 2, display: "block" }}>
              This will create a new device with the same Group and Control Config as the source
              device.
            </MDTypography>
          </MDBox>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Terminal Name *"
                fullWidth
                value={cloneFormData.terminalName}
                onChange={(e) =>
                  setCloneFormData((prev) => ({ ...prev, terminalName: e.target.value }))
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Terminal Brand *"
                fullWidth
                value={cloneFormData.terminalBrand}
                onChange={(e) =>
                  setCloneFormData((prev) => ({ ...prev, terminalBrand: e.target.value }))
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Serial Number *"
                fullWidth
                value={cloneFormData.serialNumber}
                onChange={(e) => {
                  // Allow only alphanumeric characters (no special characters)
                  const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                  setCloneFormData((prev) => ({ ...prev, serialNumber: value }));
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Device Status</InputLabel>
                <Select
                  label="Device Status"
                  value={cloneFormData.deviceStatus}
                  onChange={(e) =>
                    setCloneFormData((prev) => ({ ...prev, deviceStatus: e.target.value }))
                  }
                  IconComponent={() => (
                    <ArrowDropDownIcon sx={{ color: "black", fontSize: "25px !important" }} />
                  )}
                  sx={{ height: "45px", "& .MuiSelect-select": { pt: "14px", pb: "14px" } }}
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={performClone} color="info">
            Clone Device
          </MDButton>
          <MDButton onClick={closeCloneDialog} color="light">
            Cancel
          </MDButton>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
}

export default DeviceConfig;

